const awsmobile = {
    aws_appsync_graphqlEndpoint: 'https://ah4xphmvsbhb7ic4frsvzfbunu.appsync-api.ap-southeast-2.amazonaws.com/graphql',
    aws_appsync_region: 'ap-southeast-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_apiKey: '',
    identityPoolId: 'ap-southeast-2:631606a2-9f35-42ad-924b-bba27a8a528b',
    region: 'ap-southeast-2',
    userPoolId: 'ap-southeast-2_PwSir0SMS',
    userPoolWebClientId: '1kem79keddabijver2bffflp5r',
    oauth: {
        domain: 'paytron-prod.auth.ap-southeast-2.amazoncognito.com',
        scope: ['openid', 'email', 'profile'],
        redirectSignIn: 'https://app.paytron.com.au/xero',
        redirectSignOut: 'https://app.paytron.com.au/signin',
        responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
};

export default awsmobile;
